import { ImageSource } from 'expo-image';
import { registerImages } from '@bonanza-social/moonlight';

import providers from './providers';
import icons from './icons';
import banners from './banners';
import imgs from './images';

const images = { ...providers, ...icons, ...banners, ...imgs };

registerImages('games', images);

declare global {
  interface RegisteredImages {
    games: Record<keyof typeof images, ImageSource>;
  }
}
